module.exports = __webpack_public_path__ + "static/media/carts.ed225d64.png";